module.exports = __webpack_public_path__ + "static/media/saved_successfully_modal.048fde0c.svg";